import localforage from 'localforage'
export default {
    install(Vue, options) {
        Vue.prototype.$storage = localforage
    }
}




// WEBPACK FOOTER //
// ./src/plugins/storage/index.js